import React from 'react';
import { Icon } from 'semantic-ui-react';

export default class Button extends React.Component {
  render() {
    const {
      onClick, text, style, icon, loading, full, round, transparent, red, disabled, key, className, noBorder
    } = this.props;

    if (loading) {
      return (
        <button
          className={`icon ${className || ''}${transparent ? ' transparent' : ''}${red ? ' red' : ''}${round ? ' round' : ''}${full ? ' full-width' : ''}`}
          type="button"
          onClick={onClick}
          disabled={loading}
          style={style}
          key={key}
        >
          <Icon className="spinner spin" />
        </button>
      );
    }

    return (
      <button
        className={`${className || ''}${transparent ? ' transparent' : ''}${red ? ' red' : ''}${round ? ' round' : ''}${full ? ' full-width' : ''}${icon && text ? icon.right ? ' right-icon' : ' icon-text'  : icon ? ' icon' : ''}${noBorder ? ' no-border' : ''}`}
        type="button"
        style={style}
        onClick={onClick}
        disabled={disabled}
        key={key}
      >
        {icon && !icon.right ? <Icon className={icon?.name} style={icon?.style} /> : null}
        { text || null }
        {icon && icon.right ? <Icon className={icon?.name} style={icon?.style} /> : null}
      </button>
    );
  }
}
